/**
 * Format the given date into a relative time.
 */
Vue.filter('relative', value => {
    return moment(value).fromNow()
})

/**
 * Force a date to the past
 */
Vue.filter('past', value => {
    return moment.min(moment(), moment(value))
})

/**
 * Transform to lowercase
 */
Vue.filter('lowercase', value => {
    return value.toLowerCase()
})
